(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener('open', (event) => {
    if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
    const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
    event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
  }, true);

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('click', (event) => {
    const cartTrigger = event.target.closest('#cart-icon-bubble, .dheesh-desktop-cart');
    if (!cartTrigger) return;
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.open !== 'function') return;
    event.preventDefault();
    cartDrawer.open(cartTrigger);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiara-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tiara-video-carousel')) {
    class TiaraVideoCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tvc__track');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.prev = this.querySelector('[data-tvc-prev]');
        this.next = this.querySelector('[data-tvc-next]');
        this.dotsWrap = this.querySelector('[data-tvc-dots]');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.prev && this.prev.addEventListener('click', () => this.step(-1));
        this.next && this.next.addEventListener('click', () => this.step(1));
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.onResize = () => this.update();
        window.addEventListener('resize', this.onResize);

        this.buildDots();
        this.observeVideos();
        this.update();
        this.startAutoplay();
        this.addEventListener('pointerdown', () => this.stopAutoplay(), { passive: true });
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }

      disconnectedCallback() {
        this.stopAutoplay();
        window.removeEventListener('resize', this.onResize);
        this.observer && this.observer.disconnect();
      }

      slideStep() {
        const first = this.slides[0];
        if (!first) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      currentIndex() {
        const step = this.slideStep();
        return step ? Math.round(this.track.scrollLeft / step) : 0;
      }

      goTo(index) {
        const max = this.slides.length - 1;
        const i = Math.max(0, Math.min(max, index));
        this.track.scrollTo({ left: i * this.slideStep(), behavior: this.reduced ? 'auto' : 'smooth' });
      }

      step(direction) {
        this.goTo(this.currentIndex() + direction);
      }

      buildDots() {
        if (!this.dotsWrap) return;
        this.dotsWrap.innerHTML = '';
        this.dots = this.slides.map((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'tvc__dot';
          dot.setAttribute('aria-label', 'Go to video ' + (index + 1));
          dot.addEventListener('click', () => this.goTo(index));
          this.dotsWrap.appendChild(dot);
          return dot;
        });
      }

      update() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const atStart = this.track.scrollLeft <= 2;
        const atEnd = this.track.scrollLeft >= maxScroll - 2;
        if (this.prev) this.prev.disabled = atStart;
        if (this.next) this.next.disabled = atEnd;
        const overflow = maxScroll > 2;
        if (this.prev) this.prev.style.visibility = overflow ? '' : 'hidden';
        if (this.next) this.next.style.visibility = overflow ? '' : 'hidden';
        if (this.dotsWrap) this.dotsWrap.style.display = overflow ? '' : 'none';
        if (this.dots) {
          const current = atEnd && overflow ? this.slides.length - 1 : this.currentIndex();
          this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === current));
        }
      }

      observeVideos() {
        const videos = Array.from(this.querySelectorAll('video'));
        videos.forEach((video) => {
          video.muted = true;
          video.setAttribute('playsinline', '');
        });
        if (!('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                const attempt = video.play();
                if (attempt && attempt.catch) attempt.catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { root: null, threshold: 0.25 }
        );
        videos.forEach((video) => this.observer.observe(video));
      }

      startAutoplay() {
        this.stopAutoplay();
        if (this.dataset.autoplay !== 'true' || this.reduced || this.slides.length < 2) return;
        const seconds = Number(this.dataset.interval) || 5;
        this.timer = setInterval(() => {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          if (maxScroll <= 2) return;
          const atEnd = this.track.scrollLeft >= maxScroll - 2;
          atEnd ? this.goTo(0) : this.step(1);
        }, seconds * 1000);
      }

      stopAutoplay() {
        clearInterval(this.timer);
      }
    }
    customElements.define('tiara-video-carousel', TiaraVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
